import React from 'react';

const SummaryRow = ({ label, value, change, changeType }) => (
    <div className="clinic-dashboard-row">
        <span className="clinic-dashboard-row-label">{label}</span>
        <div className="clinic-dashboard-row-value-wrap">
            <span className="clinic-dashboard-row-value">{value}</span>
            {change && (
                <span className={`clinic-dashboard-row-change ${changeType}`}>
                    {changeType === 'up' ? '↑' : '↓'} {change}
                </span>
            )}
        </div>
    </div>
);

export default SummaryRow;
